import Vue from 'vue'
import store from '@/store'

Vue.directive('acl', {
  bind: (el, bindings) => {
    const { value } = bindings
    const { buttons } = store.getters
    if (!value) return
    if (Array.isArray(value)) {
      for (let v of value) {
        if (buttons.includes(v)) {
          return
        }
      }
      el.style.display = 'none'
      return
    }
    if (typeof value === 'string') {
      if (buttons.includes(value)) {
        return
      }
      el.style.display = 'none'
    }
  },
  
})